import { useMemo } from "react";
import { Card, Empty, Segmented, Spin, Tag } from "antd";

import { INVITATION_BUILDER_CATEGORIES } from "../invitationBuilderCategories";

export default function TemplatesPanel({
  templates,
  drafts,
  templatesLoading,
  draftsLoading,
  onApplyTemplate,
  onOpenDraft,
  category,
  onCategoryChange,
  isLoggedIn,
}) {
  const categoryOptions = useMemo(() => {
    if (!isLoggedIn) return INVITATION_BUILDER_CATEGORIES;
    return [
      ...INVITATION_BUILDER_CATEGORIES,
      { label: "My drafts", value: "drafts" },
    ];
  }, [isLoggedIn]);

  const isDraftsView = category === "drafts";

  const listLoading = isDraftsView ? draftsLoading : templatesLoading;

  const filteredTemplates =
    category === "all"
      ? templates
      : templates.filter((t) => t.category === category);

  const items = isDraftsView ? drafts ?? [] : filteredTemplates;

  return (
    <div className="invitation-builder__templates-panel">
      <div className="invitation-builder__segmented-scroll">
        <Segmented
          size="small"
          options={categoryOptions}
          value={category}
          onChange={onCategoryChange}
          className="invitation-builder__segmented"
        />
      </div>
      {listLoading ? (
        <div className="invitation-builder__center">
          <Spin />
        </div>
      ) : items.length === 0 ? (
        <Empty
          description={
            isDraftsView ? "No saved drafts yet" : "No templates"
          }
        />
      ) : (
        <div className="invitation-builder__template-grid">
          {items.map((item) => {
            const isDraft = isDraftsView;
            const key = isDraft ? `design-${item.id}` : `template-${item.id}`;
            return (
              <Card
                key={key}
                size="small"
                hoverable
                className="invitation-builder__template-card"
                onClick={() =>
                  isDraft ? onOpenDraft?.(item) : onApplyTemplate(item)
                }
                cover={
                  item.thumbnail_url ? (
                    <div className="invitation-builder__template-thumb-wrap">
                      <img alt="" src={item.thumbnail_url} />
                    </div>
                  ) : (
                    <div className="invitation-builder__template-placeholder">
                      {isDraft ? "Draft" : item.category}
                    </div>
                  )
                }
              >
                <Card.Meta
                  title={
                    <span className="invitation-builder__template-card-title">
                      {item.name}
                      {isDraft && (
                        <Tag color="blue" className="invitation-builder__draft-tag">
                          Draft
                        </Tag>
                      )}
                    </span>
                  }
                />
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
